import React from 'react';
export function TestimonialsSection() {
  return <section className="space-y-8 text-lg leading-relaxed text-stone-800 my-12" data-id="element-218">
      <div className="space-y-4" data-id="element-219">
        <h3 className="text-xl sm:text-2xl font-bold text-stone-900 font-serif leading-snug" data-id="element-220">
          6 - Avedis, you're a local dentist in Glendale — how did word spread
          so fast? And can anyone get their hands on ClearGuard Pro?
        </h3>
        <img src="https://cdn.magicpatterns.com/uploads/oJJXSgh7t8BTMjDUVwbAwM/hf_20260410_014019_07a0afbe-a8f5-4f2e-ad98-e11cc2fe46b2_(1).png" alt="Customer testimonial showing dental results" className="w-full rounded-md" data-id="element-221" />
        <p data-id="element-222">
          <strong data-id="element-223">Avedis:</strong> Honestly, I never planned on making this
          available outside of my office…
        </p>
        <p data-id="element-224">
          But the Armenian community in Glendale is tight-knit, meaning word
          travels fast.
        </p>
        <p className="font-[700]" data-id="element-225">
          And when people start seeing the kind of results that make even their
          own dentist start asking questions before they mention anything - they
          talk.
        </p>
        <p data-id="element-226">
          Within a few months, people were referring their mothers, their
          sisters, even their neighbors to my office.
        </p>
        <p data-id="element-227">
          In fact, I'd have patients coming in who I'd never seen before saying
          'my cousin told me about the mineral candy you give out…'
        </p>
        <p data-id="element-228">
          But it wasn't until I started receiving texts from numbers I didn't
          recognize — strangers thanking me for giving their smile back — that I
          realized this had grown far beyond my practice.
        </p>
        <p data-id="element-229">Here are some of the messages I received:</p>
      </div>

      <div className="grid gap-6 my-10" data-id="element-230">
        <blockquote className="bg-white border border-stone-200 border-l-4 border-l-[#2D6A4F] p-6 sm:p-8 shadow-sm" data-id="element-231">
          <p className="italic text-stone-700 font-serif text-xl font-[700]" data-id="element-232">
            "Colleen B. went for a checkup, and her periodontist was shocked!"
          </p>
        </blockquote>

        <img src="https://cdn.magicpatterns.com/uploads/mpjMPXV87ir514pmPoxd3x/Screenshot_2026-04-09_at_7.43.10_PM.png" alt="Text message testimonial from a patient thanking their dentist after their periodontist noticed healthier gums" className="w-full rounded-md" data-id="element-233" />

        <blockquote className="bg-white border border-stone-200 border-l-4 border-l-[#2D6A4F] p-6 sm:p-8 shadow-sm" data-id="element-234">
          <p className="italic text-stone-700 font-serif text-xl font-[800]" data-id="element-235">
            "Carolyn S. saved $900 because she didn't need a cleaning anymore…"
          </p>
        </blockquote>

        <img src="https://cdn.magicpatterns.com/uploads/wdqkdiLJDthBrZLfA7PKmC/Screenshot_2026-04-09_at_7.44.38_PM.png" alt="Text message testimonial from a patient whose dentist was impressed with reduced plaque and no cleaning needed" className="w-full rounded-md" data-id="element-236" />

        <blockquote className="bg-white border border-stone-200 border-l-4 border-l-[#2D6A4F] p-6 sm:p-8 shadow-sm" data-id="element-237">
          <p className="italic text-stone-700 font-serif text-xl font-[800]" data-id="element-238">
            "Maureen L. was feeling hopeless about her teeth and smile…"
          </p>
        </blockquote>

        <img src="https://cdn.magicpatterns.com/uploads/anDAd4oW78fzEUVmSsHfUx/Screenshot_2026-04-09_at_7.47.48_PM.png" alt="Text message testimonial from a patient expressing joy at being able to smile freely thanks to the protocol" className="w-full rounded-md" data-id="element-239" />

        <blockquote className="bg-white border border-stone-200 border-l-4 border-l-[#2D6A4F] p-6 sm:p-8 shadow-sm" data-id="element-240">
          <p className="italic text-stone-700 font-serif text-xl font-[800]" data-id="element-241">
            "Barbara P. thought she would be doomed with cavities forever…"
          </p>
        </blockquote>

        <img src="https://cdn.magicpatterns.com/uploads/1p2MTVCkYcxhWszVh4AfJP/Screenshot_2026-04-09_at_7.48.37_PM.png" alt="Text message testimonial from a patient who went from frequent cavities to none in almost 6 months" className="w-full rounded-md" data-id="element-242" />
      </div>

      <div className="space-y-4" data-id="element-243">
        <p className="font-[700]" data-id="element-244">
          For a long time I wasn't comfortable with the idea of sharing it
          online because I'm simply a dentist who fixes teeth for a living.
        </p>
        <p data-id="element-245">In other words, it's never been about selling something.</p>
        <p data-id="element-246">
          But the demand became impossible to ignore, and I felt as if God was
          urging me to share it with the world.
        </p>
        <p className="font-[400]" data-id="element-247">
          So I made a decision that my accountant and lawyer both strongly
          advised against…
        </p>
        <p data-id="element-248">
          Since it's our official online launch, I ordered a special shipment.
        </p>
        <p data-id="element-249">The honest answer to your question though?</p>
        <p className="font-[700]" data-id="element-250">
          While it's finally available for everyone, I don't know how long this
          limited batch will last.
        </p>
        <p data-id="element-251">
          Since we're a small operation, we don't manufacture in the volumes
          that big supplement companies do.
        </p>
        <p data-id="element-252">
          Not because we can't, but because we refuse to compromise on the
          sourcing of the hydroxyapatite or the viability of the probiotic
          strains.
        </p>
        <p className="font-[400]" data-id="element-253">
          So if you're reading this and the link below still works — you're in
          time. But I genuinely cannot guarantee how long that will be the case.
        </p>
      </div>
    </section>;
}